/** Onde statuses that mean a ride is under way — blocks creating a new one (mirrors the backend's `RideService.InProgressStatusList`). */
export const IN_PROGRESS_RIDE_STATUSES = ['SEARCH', 'ASSIGNED', 'STARTED', 'ARRIVED', 'TRANSFERRING'];

/** The passenger already reached the destination (paid or not) — same next step either way. */
export const CONFIRMATION_RIDE_STATUSES = ['REVIEW_SUMMARY', 'PAYMENT', 'FINISHED_PAID', 'FINISHED_UNPAID'];

/** Every way Onde can terminate a ride without a completed trip. */
export const CANCELLED_RIDE_STATUSES = [
  'CANCELLED_BY_DISPATCH',
  'CANCELLED_BY_DRIVER',
  'CANCELLED_NO_PASSENGER',
  'CANCELLED_DECIDED_NOT_TO_GO',
  'CANCELLED_NO_TAXI',
  'CANCELLED_DRIVER_OFFLINE',
  'CANCELLED_SEARCH_EXCEEDED',
];

export const isRideInProgress = (status?: string | null): boolean =>
  !!status && IN_PROGRESS_RIDE_STATUSES.includes(status);

export const isRideConfirmationReady = (status?: string | null): boolean =>
  !!status && CONFIRMATION_RIDE_STATUSES.includes(status);

export const isRideCancelled = (status?: string | null): boolean =>
  !!status && CANCELLED_RIDE_STATUSES.includes(status);

export type RidePhase = 'enroute' | 'arrived' | 'transferring';

export const getRidePhase = (status?: string | null): RidePhase =>
  status === 'ARRIVED' ? 'arrived' : status === 'TRANSFERRING' ? 'transferring' : 'enroute';
